import { inject, Injectable } from "@angular/core";
import { MCHttpWrapperService, MCResponse } from "@maslul/common-services";
import { Observable } from "rxjs";

@Injectable({
    providedIn: 'root'
})
export class MIUnionRequestHttpService {
    myImportControllerUrl: string = 'MyImport';
    requestControllerUrl: string = 'Request';

    unionRequestApi: string = 'api/MIUnionRequest/';

    private httpWrapperService = inject(MCHttpWrapperService);



    GetApprovalTabs(approvalTypeIds: Array<number> | null = null, approvalMainTypeIds: Array<number> | null = null): Observable<MCResponse> {//??

        let url = "";

        approvalTypeIds?.forEach(approvalTypeId => {
            url += "approvalTypesId=" + approvalTypeId + "&";
        });
        approvalMainTypeIds?.forEach(pprovalMainTypeId => {
            url += "mainTypesId=" + pprovalMainTypeId + "&";
        });
        url = this.unionRequestApi + this.myImportControllerUrl + '/approval-tabs?' + url.substring(0, url.length - 1);
        return this.httpWrapperService.getData(url)
    }

    send(requestData: any): Observable<MCResponse> {
        const url = this.unionRequestApi + this.myImportControllerUrl + '/send'
        const sendRequest: Observable<MCResponse> = this.httpWrapperService.sendData(url, requestData) as Observable<MCResponse>;
        return sendRequest;
    }

    getExistRequest(unionRequestId: string): Observable<MCResponse> {
        const url = this.unionRequestApi + this.requestControllerUrl + '/get-request/' + unionRequestId
        const getRequest: Observable<MCResponse> = this.httpWrapperService.getData(url) as Observable<MCResponse>;
        return getRequest;
    }

    updateFieldSchema(updateFieldSchema: any) {//schema properties

    }

}